<script setup lang="ts">
import { useFeedback } from '../composables/useFeedback';

// Single render site for everything useFeedback() queues. Mounted once, in App.vue.
const { notices, confirmRequest } = useFeedback();

function accept() {
  confirmRequest.value?.onAccept();
  confirmRequest.value = null;
}
</script>

<template>
  <!-- The queue shows one notice at a time and holds the rest by default, so a sticky notice
       (life omitted, e.g. session expired) would block every later one until dismissed by hand.
       Stack a few and let the oldest give way instead. -->
  <v-snackbar-queue v-model="notices" location="top right" :total-visible="3" display-strategy="overflow" closable />

  <v-dialog :model-value="Boolean(confirmRequest)" max-width="28rem" @update:model-value="confirmRequest = null">
    <v-card v-if="confirmRequest">
      <v-card-title class="d-flex align-center ga-2">
        <v-icon icon="warning" color="warning" size="small" />
        <span>{{ confirmRequest.title }}</span>
      </v-card-title>
      <v-card-text>{{ confirmRequest.message }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text="Cancel" variant="text" @click="confirmRequest = null" />
        <v-btn :text="confirmRequest.acceptLabel" color="error" variant="flat" @click="accept" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
